<template>
  <div id="block-level">
    <Take5DailyLayout :isListPage="true">
      <MediaGrid 
        v-if="!pending && data"
        class="lg:col-span-3"
        :primary="primary"
        :secondary="secondary"
        :tertiary="tertiary"
        :currentPage="currentPage"
        :limit="limit"
        :currentSearch="searchQuery"
        :hasNext="hasNext"
        :hasPrev="hasPrev"
        :totalPages="totalPages"
        titlePosition="bottom"
        :showSearch="true"
      />
      <div v-else-if="pending" class="border-r-0 md:border-r md:border-gray-300 lg:col-span-3 
               flex items-center justify-center py-20">
        <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    </Take5DailyLayout>
  </div>
</template>

<script setup lang="ts">
import Take5DailyLayout from '~/layouts/take5daily.vue';
import MediaGrid from '~/components/ui/organism/take-five-daily/mediaGrid.vue';
import { useScrollToTop } from '~/composables/useScrollToTop';
import { useTakeFiveDaily } from '~/composables/useTakeFiveDaily';

definePageMeta({
  layout: 'take-5-daily' as any
})

const { 
  data, 
  error, 
  pending, 
  primary, 
  secondary, 
  tertiary,
  currentPage,
  searchQuery,
  limit,
  hasNext,
  hasPrev,
  totalPages
} = useTakeFiveDaily('articles');

useScrollToTop(currentPage);
</script>
